// extracted by css-extract-rspack-plugin
export default {"mainPhoto":"_2cfdb31e"};